import { render, staticRenderFns } from "./EditableDraggableList.vue?vue&type=template&id=1a26f342&"
import script from "./EditableDraggableList.vue?vue&type=script&lang=js&"
export * from "./EditableDraggableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports